<template>
  <section id="sequence-summary" class="sequence-summary">
    <div class="sequence-summary__identity">
      <user-avatar :width="72" :height="72" :image-path="associate.photo_url ? associate.photo_url : undefined" />
      <div class="flex flex-column gap-2">
        <h2 class="m-0">{{ associateFullName }}</h2>
        <div class="sequence-muted">Associate #{{ associate.associate_number || '-' }}</div>
        <div class="sequence-summary__meta">
          <export-button
            v-if="isReviewedView && sequence"
            class="sequence-summary__export"
            :export-payload="exportPayload"
            type=""
          />
        </div>
      </div>
    </div>

    <div class="sequence-summary__grid">
      <div class="summary-item">
        <span>Sequence</span>
        <b>{{ sequence.project_sequence_name || typeTitle || '-' }}</b>
      </div>
      <div class="summary-item">
        <span>Type</span>
        <b>{{ typeTitle || '-' }}</b>
      </div>
      <div class="summary-item">
        <span>Status</span>
        <b :style="{ color: sequenceStatusColor }">{{ sequenceStatusTitle }}</b>
      </div>
      <div class="summary-item">
        <span>Completed date</span>
        <b>{{ completedDate }}</b>
      </div>
      <div class="summary-item">
        <span>Reviewed by</span>
        <b>{{ reviewerName }}</b>
      </div>
      <div class="summary-item">
        <span>Reviewed date</span>
        <b>{{ reviewedDate }}</b>
      </div>
      <div class="summary-item">
        <span>Associate steps</span>
        <b>{{ associateStepsCompleted }}/{{ associateStepsTotal }}</b>
      </div>
      <div class="summary-item" v-if="adminStepsTotal">
        <span>Admin tasks</span>
        <b>{{ adminStepsCompleted }}/{{ adminStepsTotal }}</b>
      </div>
    </div>
  </section>
</template>

<script>
import ExportButton from '@/components/export-button.vue'
import UserAvatar from '@/components/ui/user-avatar.vue'
import { Tag } from 'ant-design-vue'
import {
  formatDateTime,
  getAssociateFullName,
  getReviewerName,
  getSequenceStatusColor,
  getSequenceStatusTitle,
  getTypeTitle
} from './sequence-review.helpers'

export default {
  name: 'SequenceReviewSummary',
  components: {
    'a-tag': Tag,
    'export-button': ExportButton,
    'user-avatar': UserAvatar
  },
  props: {
    sequence: {
      type: Object,
      required: true
    },
    associate: {
      type: Object,
      default: () => ({})
    },
    isReviewedView: {
      type: Boolean,
      default: false
    },
    associateStepsCompleted: {
      type: Number,
      default: 0
    },
    associateStepsTotal: {
      type: Number,
      default: 0
    },
    adminStepsCompleted: {
      type: Number,
      default: 0
    },
    adminStepsTotal: {
      type: Number,
      default: 0
    },
    exportPayload: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    associateFullName() {
      return getAssociateFullName(this.associate)
    },
    typeTitle() {
      return getTypeTitle(this.sequence?.type)
    },
    sequenceStatusTitle() {
      return getSequenceStatusTitle(this.sequence?.completion_status)
    },
    sequenceStatusColor() {
      return getSequenceStatusColor(this.sequence?.completion_status)
    },
    completedDate() {
      return formatDateTime(this.sequence?.updated_at)
    },
    reviewerName() {
      return getReviewerName(this.sequence?.reviewer_signature)
    },
    reviewedDate() {
      return formatDateTime(this.sequence?.reviewer_signature?.signed_date)
    }
  }
}
</script>

<style scoped>
.sequence-summary {
  border: 1px solid var(--border-color-base);
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: minmax(240px, 1fr) 2fr;
  gap: 16px;
  align-items: start;
}

.sequence-summary__identity {
  display: flex;
  gap: 12px;
  align-items: start;
}

.sequence-summary__identity h2 {
  line-height: 1;
}

.sequence-summary__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.sequence-summary__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  gap: 12px;
}

.sequence-summary__export {
  line-height: 1;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.summary-item span,
.sequence-muted {
  color: #6b7280;
  font-size: 12px;
}

@media screen and (max-width: 1200px) {
  .sequence-summary {
    grid-template-columns: 1fr;
  }

  .sequence-summary__grid {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
}

@media screen and (max-width: 640px) {
  .sequence-summary__grid {
    grid-template-columns: 1fr;
  }
}
</style>
